module.exports = __webpack_public_path__ + "img/ics_f_check_circle_green.951edf65.svg";